import { Button } from "@common/index";
import type { TurnstileState } from "../_helpers/useTurnstile";

const LOADING = "Loading the security check…";
const PENDING = "Complete the security check to submit.";
const LOAD_FAILED =
    "We couldn't load the security check, so this form can't be sent yet. Check your connection and try again.";

interface TurnstileCheckProps {
    turnstile: TurnstileState;
}

// The Turnstile widget's place in an onboarding form (OB-06), plus why the form is waiting:
// an honest hint while the check loads or is unanswered, or an announced error with Retry
// when the script could not load — never a silently disabled submit button. Renders nothing
// while Turnstile is off. Sits ahead of the submit button, so the widget is in tab order.
// Destructured in the signature: the React Compiler lint treats an object as a ref once one
// of its fields reaches `ref=`, and would flag every other field read from it.
export const TurnstileCheck = ({
    turnstile: { isEnabled, status, isAwaitingToken, hintId, setContainer, retry },
}: TurnstileCheckProps) => {
    if (!isEnabled) {
        return null;
    }

    return (
        <div className="space-y-2">
            <div ref={setContainer} />

            {status === "failed" ? (
                <div id={hintId} role="alert" className="alert alert-error">
                    <span>{LOAD_FAILED}</span>
                    <Button onClick={retry}>Retry</Button>
                </div>
            ) : (
                isAwaitingToken && (
                    <p id={hintId} role="status" className="text-sm">
                        {status === "loading" ? LOADING : PENDING}
                    </p>
                )
            )}
        </div>
    );
};
